export default class DebugLog {
  static consolelog(isDebugOn: boolean = false, message: string) {
    if (isDebugOn) {
      console.log(message);
    }
  }
}
